<template>
  <div class="monitor" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <townName ref="townlist" v-on:townadcd="townAdcd"></townName>
      <div class="yuliang" ref="yuliang">
        <div class="select">
          <span class="desc">站名:</span>
          <el-input
            @change="nameSelect"
            v-model="inputData"
            clearable
            placeholder="请输入站名"
          ></el-input>
          <span id="select" @click="searchData">查询</span>
          <span @click="exportdata" id="export"><span class="export-icon"></span>导出</span>
        </div>
        <div class="raintable">
          <el-table
            v-loading="loading"
            :row-class-name="tableRowClassName"
            :data="tdata"
            :max-height="height"
            border
            header-align="center"
            style="width: 100%;"
          >
            <el-table-column
              fixed
              type="index"
              width="60"
              label="序号"
              align="center"
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="addvnm"
              label="乡镇"
              sortable
              align="center"
              header-align="center"
              min-width="120"
            >
            </el-table-column>
            <el-table-column
              prop="stnm"
              label="站名"
              sortable
              align="center"
              header-align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <!-- <div class="overflowWarn">
                  <span
                    @click="stationchart(scope.row)"
                    style="cursor:pointer!important;font-weight:bold"
                    >{{ scope.row.stnm }}</span
                  >
                </div> -->
                <el-tooltip effect="dark" :content="scope.row.stnm + ' ' + (scope.row.stcd?scope.row.stcd:'')" placement="top" class="item" popper-class="hiddenOverflow">
                  <div class="overflowWarn">
                    <span @click="stationchart(scope.row)" style="cursor:pointer!important;font-weight:bold">{{ scope.row.stationName }}</span>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="waterAtEight"
              align="center"
              header-align="center"
              label="8时水位(m)"
              min-width="120"
              sortable
              :sort-method="sortChange1"
            >
              <template slot-scope="scope">
                <span>{{scope.row.waterAtEight | rounding}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              header-align="center"
              label="当前水位时间"
              min-width="150"
              sortable
            >
            <template slot-scope="scope">
              <span :style="new Date(scope.row.time) <  timecompare? 'color:red;':''" v-if="scope.row.time">{{scope.row.time.slice(5)}}</span>
              <span v-else>-</span>
            </template>
            </el-table-column>
            <el-table-column
              prop="water"
              align="center"
              header-align="center"
              label="当前水位(m)"
              min-width="120"
              sortable
              :sort-method="sortChange2"
            >
            <template slot-scope="scope">
                <span>{{scope.row.water | rounding}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="warningWater"
              align="center"
              header-align="center"
              label="警戒水位(m)"
              min-width="120"
              sortable
              :sort-method="sortChange3"
            >
            <template slot-scope="scope">
                <span>{{scope.row.warningWater | rounding}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="overflowWarningWater"
              align="center"
              header-align="center"
              label="超警戒水位(m)"
              min-width="120"
              sortable
              :sort-method="sortMethod1"
            >
              <!-- <template slot-scope="scope">
                <div class="overflowWarn">
                  <font v-if="scope.row.overflowWarningWater > 0" color="red">{{
                    scope.row.overflowWarningWater
                  }}</font>
                  <font v-else>{{ scope.row.overflowWarningWater_Str }}</font>
                </div>
              </template> -->
              <template slot-scope="scope">
                <font v-if="scope.row.overflowWarningWater > 0" color="red">{{scope.row.overflowWarningWater | rounding}}</font>
                <font v-else>{{ scope.row.overflowWarningWater }}</font>
              </template>
            </el-table-column>
            <el-table-column
              prop="guaranteeWater"
              align="center"
              header-align="center"
              label="保证水位(m)"
              min-width="120"
              sortable
              :sort-method="sortChange5"
            >
            <template slot-scope="scope">
                <span>{{scope.row.guaranteeWater | rounding}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="overflowGuaranteeWater"
              align="center"
              header-align="center"
              label="超保证水位(m)"
              min-width="120"
              sortable
              :sort-method="sortMethod2"
            >
            <template slot-scope="scope">
              <font v-if="scope.row.overflowGuaranteeWater > 0" color="#f3f364">{{scope.row.overflowGuaranteeWater | rounding}}</font>
              <font v-else>{{scope.row.overflowGuaranteeWater | rounding}}</font>
            </template>
            <!-- <template slot-scope="scope">
                <span>{{scope.row.overflowGuaranteeWater | rounding}}</span>
              </template> -->
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <stationDialog ref="stationDialog"></stationDialog>
  </div>
</template>
<script>
import monitorTypes from '@/store/types/monitor'
import townName from '@/components/Townname'
import stationDialog from '@/components/stationDialog'
import timer from '@/utils/timer'
export default {
  name: 'MonitoringCenter',
  components: {
    townName, stationDialog
  },
  data () {
    return {
      maxZ_Time: '',
      lastestZ: '',
      maxZ: '',
      thestation: '',
      dialogVisible: false,
      loading: true,
      loading1: true,
      height: 10,
      // choosed: 0,
      aDDVCD: '',
      stationName: '',
      isTown: true,
      searchName: '',
      tdata: [],
      tdata2: [],
      all: true,
      adcdtotal: '',
      pageIndex: 1,
      pageSize: 100,
      towns: [],
      inputData: '',
      sTID: '',
      time: '',
      chartwaterValues: [],
      chartxline: [],
      chartwrZs: [],
      chartrainValues: [],
      datev: '',
      radio: '1',
      dateselect: true,
      sID: 22,
      myChart: {},
      timerFun: '',
      minWarning: 0,
      minGuarantee: 0,
      timecompare: new Date(new Date() - 1200000)
      // n: ''
    }
  },
  computed: {
  },
  methods: {
    // 行政区划选择
    townAdcd: function (townAdcd) {
      this.loading = true
      this.aDDVCD = townAdcd
      this.tabledata()
    },
    // 列排序
    sortChange1 (a, b) {
      // return a.waterAtEight - b.waterAtEight
      let bsort = b.waterAtEight === undefined ? -1 : b.waterAtEight
      let asort = a.waterAtEight === undefined ? -1 : a.waterAtEight
      return bsort - asort
    },
    sortChange2 (a, b) {
      // return a.water - b.water
      let bsort = b.water === undefined ? -1 : b.water
      let asort = a.water === undefined ? -1 : a.water
      return bsort - asort
    },
    sortChange3 (a, b) {
      // return a.warningWater - b.warningWater
      let bsort = b.warningWater === undefined ? -1 : b.warningWater
      let asort = a.warningWater === undefined ? -1 : a.warningWater
      return bsort - asort
    },
    sortChange4 (a, b) {
      return a.overflowWarningWater - b.overflowWarningWater
    },
    sortChange5 (a, b) {
      // return a.guaranteeWater - b.guaranteeWater
      let bsort = b.guaranteeWater === undefined ? -1 : b.guaranteeWater
      let asort = a.guaranteeWater === undefined ? -1 : a.guaranteeWater
      return bsort - asort
    },
    sortChange6 (a, b) {
      return a.overflowGuaranteeWater - b.overflowGuaranteeWater
    },
    sortMethod1 (a, b) {
      let bsort = b.overflowWarningWater === undefined ? this.minWarning - 1 : Number(b.overflowWarningWater)
      let asort = a.overflowWarningWater === undefined ? this.minWarning - 1 : Number(a.overflowWarningWater)
      return bsort - asort
    },
    sortMethod2 (a, b) {
      let bsort = b.overflowGuaranteeWater === undefined ? this.minGuarantee - 1 : Number(b.overflowGuaranteeWater)
      let asort = a.overflowGuaranteeWater === undefined ? this.minGuarantee - 1 : Number(a.overflowGuaranteeWater)
      return bsort - asort
    },
    stationchart (item) {
      this.$refs.stationDialog.showlog(item, '#2F4F4F')
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0 && (row.overflowGuaranteeWater <= 0 || row.overflowGuaranteeWater === undefined)) {
        return 'warning-row'
      } else if (row.overflowGuaranteeWater > 0) {
        return 'red-row'
      }
      return ''
    },
    nameSelect () {
      this.stationName = this.inputData
      console.log(this.inputData)
      this.tabledata()
    },
    searchData () {
      this.stationName = this.inputData
      this.tabledata()
    },
    towndata () {
      let arr = []
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        searchName: this.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.adcdtotal = data.total
        this.towns = data.results
        this.towns.forEach(item => {
          let obj = { adcd: '', adnm: '', id: 0, lat: 0.0, lng: 0.0, modifyTime: '', check: false }
          obj.adcd = item.adcd
          obj.adnm = item.adnm
          obj.id = item.id
          arr.push(obj)
        })
        this.towns = arr
      })
    },
    tabledata () {
      this.loading = true
      this.$store.dispatch(monitorTypes.GET_STATISTICS_RIVER_WATER, {
        aDDVCD: this.aDDVCD,
        sID: this.sID,
        sTID: this.sTID,
        stationName: this.stationName,
        mainStation: true
      }).then(data => {
        this.tdata = data.rows
        this.loading = false
        // this.dataSort('overflowWarningWater', this.tdata)
        // 河道水位超警戒排序,获取超警戒最小值
        let filterWaterData = this.tdata.filter(item => { // 过滤数组中undefined类型
          return item.overflowWarningWater !== undefined
        })
        let min = Math.min.apply(Math, filterWaterData.map(item => { return item.overflowWarningWater }))
        this.minWarning = min
        this.tdata = this.tdata.sort((a, b) => {
          let bsort = b.overflowWarningWater === undefined ? this.minWarning - 1 : Number(b.overflowWarningWater)
          let asort = a.overflowWarningWater === undefined ? this.minWarning - 1 : Number(a.overflowWarningWater)
          return bsort - asort
        })
        // 河道水位超保证排序,获取超保证最小值
        let filterGuaranteeWaterData = this.tdata.filter(item => { // 过滤数组中undefined类型
          return item.overflowGuaranteeWater !== undefined
        })
        let min1 = Math.min.apply(Math, filterGuaranteeWaterData.map(item => { return item.overflowGuaranteeWater }))
        this.minGuarantee = min1
        // 超警戒河道
        let overflowWarningWaterArr = this.tdata.filter(el => {
          return el.overflowWarningWater > 0
        })
        // 未超警戒河道
        let noneOverflowWarningWaterArr = this.tdata.filter(el => {
          return !el.overflowWarningWater || el.overflowWarningWater <= 0
        })
        // 乡镇首字母排序
        let sortAddvnmArr = this.firstLetterSort(noneOverflowWarningWaterArr)
        let tableData = overflowWarningWaterArr.concat(sortAddvnmArr) // 超汛限排前，后面排按乡镇首字母排序
        this.tdata = tableData
      })
    },
    // 乡镇首字母排序
    firstLetterSort(item) {
      let resultArray = item.sort(
        function compareFunction(a, b) {
          return a.addvnm.localeCompare(b.addvnm, 'zh')
        }
      )
      return resultArray
    },
    // 数据排序
    dataSort (type, sortData) {
      this.sortType = type
      sortData.sort(this.compare(type))
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val2 - val1
      }
    },
    exportdata () {
      this.$store.dispatch(monitorTypes.EXPORT_RIVER_WATER, {
        aDDVCD: this.aDDVCD,
        stationName: this.stationName,
        mainStation: true
      }).then(data => {
        window.location.href = this.Global.basePath + data.data
        // window.location.href
      })
    }
  },
  filters: {
    rounding (num) {
      var result = parseFloat(num)
      if (isNaN(result)) {
        return '-'
      } else if (result === 0) {
        return num
      }
      result = Math.round(num * 100) / 100
      var value = result.toString() // 将数字转换为字符串

      let posdecimal = value.indexOf('.') // 小数点的索引值

      // 当整数时，posdecimal=-1 自动补0
      if (posdecimal < 0) {
        posdecimal = value.length
        value += '.'
      }

      // 当数字的长度< 小数点索引+2时，补0
      while (value.length <= posdecimal + 1) {
        value += '0'
      }
      // console.log(typeof value)
      // let val = parseFloat(value)
      return value
    }
  },
  mounted () {
    // this.datev = new Date()
    this.towndata()
    this.tabledata()
    this.timerFun = setInterval(this.searchData, timer.TIMER_MIN)
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height = (contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45) + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['yuliang'].offsetHeight - selectDiv[0].offsetHeight - 20
    })
  },
  beforeDestroy () {
    clearInterval(this.timerFun)
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style lang="less" scoped>
  .monitor {
    .content {
      .yuliang {
        .select {
          .el-input {
            width: 165px;
          }
        }
      }
    }
  }
  #station{
    width: 100%;
    height: 400px;
  }
.ascension{
  background-color: #d99696
}
/* // 样式穿透 */
  .content /deep/ .yuliang .raintable .el-table .warning-row{
    background:#f3f364 !important;
  }
  .content /deep/ .yuliang .raintable .el-table .red-row{
    background:#f37564 !important;
  }
  .ascension {
    background-color: #d99696;
  }
  .block{
    position: absolute;
    width: 95%;
    top: 15px;
    left: 0;
    text-align: center;
  }
  .chartshuiwei{
    text-align: center;
    width: 100%;
    // float: right;
  }
</style>
